import React, { useEffect, useState } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { sanitizeHtml } from '@/lib/sanitize';
import { ArrowLeft } from 'lucide-react';

export default function LegalPage() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/legal-documents/${slug}`)
      .then(({ data }) => { if (alive) setDoc(data); })
      .catch((e) => { if (alive) setError(e?.response?.status === 404 ? '404' : (e?.message || 'error')); });
    return () => { alive = false; };
  }, [slug]);

  if (error === '404') return <Navigate to="/" replace />;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-16" data-testid="legal-page">
      <Link to="/" className="text-xs font-mono text-[var(--pg-ink-faint)] hover:text-[var(--pg-ink)] inline-flex items-center gap-1 mb-6">
        <ArrowLeft size={12} /> Home
      </Link>
      {!doc ? (
        <p className="text-sm text-[var(--pg-ink-muted)]">Loading…</p>
      ) : (
        <article className="prose-invert max-w-none">
          <h1 className="font-serif text-3xl lg:text-4xl text-[var(--pg-ink)] mb-2">{doc.title}</h1>
          {doc.effective_date && (
            <p className="text-[11px] font-mono tracking-widest text-[var(--pg-ink-faint)] mb-8 uppercase">Effective {doc.effective_date} · v{doc.version}</p>
          )}
          <div className="text-[var(--pg-ink-muted)] leading-relaxed"
               dangerouslySetInnerHTML={{ __html: sanitizeHtml(doc.body_html || '') }} />
        </article>
      )}
    </div>
  );
}
